import script from "./MoleculeModalAccordionTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeModalAccordionTable.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeModalAccordionTable.vue?vue&type=style&index=0&id=463c8482&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463c8482"]])

export default __exports__